import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const deleteCheckoutWidget = {
  name: "deleteCheckoutWidget" as const,
  input: z.object({ widgetId: zExt.objectId() }),
  output: z.discriminatedUnion("success", [
    z.object({ success: z.literal(true) }),
    z.object({ success: z.literal(false), reason: z.string() }),
  ]),
};
